/**
 * useAuth hook for accessing authentication context
 * Re-exports the real useAuth from features/auth for shared usage
 */

import { useAuth as useAuthFeature } from '@features/auth/hooks/useAuth';
import type { User } from '@features/auth/types';

// Re-export types for backward compatibility
export type { User as AuthUser };
export type { UseAuthReturn as AuthContextType } from '@features/auth/hooks/useAuth';

/**
 * Hook to access authentication context
 * Uses the real auth implementation from features/auth
 */
export function useAuth() {
  const auth = useAuthFeature();

  // Map to the expected interface for backward compatibility
  return {
    user: auth.user,
    isLoading: false, // AuthProvider handles loading state
    isAuthenticated: auth.isAuthenticated,
    hasPermission: auth.hasPermission,
    hasRole: (role: string) => {
      if (!auth.user) return false;
      return auth.user.roles.includes(role);
    },
    logout: auth.logout,
  };
}
